import React, { useMemo } from 'react';
import { Flex, xcss } from '@atlaskit/primitives';
import { extractValuesFromNonComplexJQL } from '../utils/extractValuesFromNonComplexJQL';
import AsyncPopupSelect from './async-popup-select';
export var availableBasicFilterTypes = ['project', 'type', 'status', 'assignee'];
var basicFilterContainerStyles = xcss({
  paddingLeft: 'space.100'
});
var BasicFilterContainer = function BasicFilterContainer(_ref) {
  var jql = _ref.jql,
    site = _ref.site,
    onChange = _ref.onChange,
    selections = _ref.selections,
    isJQLHydrating = _ref.isJQLHydrating;
  var extractedFilterValues = useMemo(function () {
    return isJQLHydrating ? extractValuesFromNonComplexJQL(jql) : {};
  }, [isJQLHydrating, jql]);
  var _ref2 = site || {},
    cloudId = _ref2.cloudId;
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: basicFilterContainerStyles,
    gap: "space.100",
    testId: "jlol-basic-filter-container"
  }, availableBasicFilterTypes.map(function (filter) {
    var _extractedFilterValue;
    var shouldShowHydrationLoader = isJQLHydrating && ((_extractedFilterValue = extractedFilterValues[filter]) === null || _extractedFilterValue === void 0 ? void 0 : _extractedFilterValue.length) > 0;
    return /*#__PURE__*/React.createElement(AsyncPopupSelect, {
      site: site,
      filterType: filter,
      key: filter,
      selection: selections[filter] || [],
      isJQLHydrating: shouldShowHydrationLoader,
      isDisabled: !cloudId,
      onSelectionChange: onChange
    });
  }));
};
export default BasicFilterContainer;